export const CONSENT_MODES = [
  "publisher-cmp-tag",
  "own-cookiebot",
  "none-with-footer-link",
  "none",
] as const;

export type ConsentMode = (typeof CONSENT_MODES)[number];

export type GtmConsentCategory = "granted" | "denied";

export type GtmConsentState = {
  ad_storage: GtmConsentCategory;
  ad_user_data: GtmConsentCategory;
  ad_personalization: GtmConsentCategory;
  analytics_storage: GtmConsentCategory;
};

export type TcfCmpStatus = "stub" | "loading" | "loaded" | "error";

export type TcfEventStatus = "tcloaded" | "cmpuishown" | "useractioncomplete";

export type TcfData = {
  cmpStatus?: TcfCmpStatus;
  eventStatus?: TcfEventStatus;
  purpose?: { consents: Record<number, boolean> };
  gdprApplies?: boolean;
};

export const CONSENT_DENIED: GtmConsentState = {
  ad_storage: "denied",
  ad_user_data: "denied",
  ad_personalization: "denied",
  analytics_storage: "denied",
};

export const CONSENT_GRANTED: GtmConsentState = {
  ad_storage: "granted",
  ad_user_data: "granted",
  ad_personalization: "granted",
  analytics_storage: "granted",
};

declare global {
  interface Window {
    __tcfapi?: (
      command: string,
      version: number,
      callback: (data: TcfData, success: boolean) => void,
      parameter?: unknown,
    ) => void;
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}
